import _ from "lodash";
import * as types from "../../constants/PhotoShotsActionsTypes";

const initState = {
  fetching: false,
  fetched: false,
  failed: false,
  data: {
    shots: {},
    progress: 0,
    size: 0
  }
};

const reducer = (state = initState, action) => {
  switch (action.type) {
    case types.PHOTO_SHOT_FETCHING:
      return {
        ...state,
        fetching: true
      };
    case types.PHOTO_SHOT_FETCHED:
      let data = Object.assign({}, state.data, { shots: action.data.shots, progress: action.data.progress, size: action.length });
      return {
        fetching: false,
        fetched: true,
        failed: true,
        data
      };
    case types.PHOTO_SHOT_FAILED:
      return {
        ...state,
        fetching: false,
        failed: true
      };
    case "SHOOT_CLEAR":
      return {
        fetching: false,
        fetched: false,
        failed: false,
        data: {
          shots: {},
          progress: 0,
          size: 0
        }
      };
    default:
      return state;
  }
};

export default reducer;
